import * as React from "react";
import Component from "../../AbstractComponent";
import { PromptDialog } from "./PromptDialog";
import { PaymentInterface } from "../../../Entity/Entities/Payment/PaymentInterface";
import Constants from "../../../Action/Constants";
import { Company } from "../../../Entity/Entities/Company/Company";
import { Person } from "../../../Entity/Entities/Person/Person";
import PaymentCounterpartyDescriptionInfoForList from "../../Partials/Payment/PaymentCounterpartyDescriptionInfoForList";
import Payments2List from "../../Partials/Payment/Payments2List";
import PaymentClassContainer from "../../../Entity/Entities/Payment/PaymentClass/PaymentClassContainer";
import { PageTransition } from "../Spinner/PageTransition";
import PaymentTypeContainer from "../../../Entity/Entities/Payment/PaymentType/PaymentTypeContainer";
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Checkbox from '@material-ui/core/Checkbox';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';

export class CoachSettlePayment extends Component {
  protected timer;

  public defaultState = {
    isOpen: false,
    step: this.props.step ? this.props.step : 1,
    payerPayments: [],
    selectedDirectIndirectPaymentsRows: [],
    directIndirectPayments: [],
    selectedPayerPaymentsRows: [],
    selectedFilteredPaymentsRows: [],
    isSaving: false,
    selectedPersonForPayment: null,
    selectedCompanyForPayment: null,
    descriptionForPayment: "",
    filteredPayments: [],
    paymentSearchInProgress: false,
    descriptionForPaymentIsManuallyChanged: false,
    paymentSearchString: "",
    selectedCounterpartyForNewPayment: null,
    directIndirectCharges: [],
    selectedDirectIndirectChargesRows: [],
    objectCharges: [],
    selectedObjectChargesRows: [],
    paymentIds: [],
    isSaveButtonClicked: false,
    payment: null,
    chargeSearchString: "",
    chargeSearchInProgress: false,
    selectedCharge: null,
    activeStep: 0,
    skipped: new Set(),
    hasModifiedData: false,
    openLeavePrompt: false,
    errorFields: null,
    isClosePreprocessDialogOpen: false,

    paymentChoice: "",
    amountForPayment: "",
    selectedPayment: null,
    currencyIdForPayment: null,
    dateForPayment: new Date(),
    typeIdForPayment: String(PaymentTypeContainer.pickIdFromLabel("Bank")),
    agencyBankAccountIdForPayment: null,
    counterpartyIbanForPayment: "",
    originalCounterpartyIban: null,
    companyBankIdForPayment: "",
    paymentClassId: null,
    payerChoice: "person",
    existingPayerChoice: "person",
    selectedPersonForExistingPayments: null,
    selectedCompanyForExistingPayments: null,
    fetchedPayments: [],
    anchorPaymentEl: null,
    isPaymentUnSettlePopupOpen: false,
    isPaymentUnlinkPopupOpen: false,
    isPaymentRemovePopupOpen: false,
    paymentFirstDate: new Date(),
    isProcessed: false,
    renderSelectCounterpartyFields: false,
    clearCounterpartyState: false,
    paymentToAddNote: null,
    note: "",
    memoPopupOpen: false,
    showPaymentCardSummaryView: true,
  };

  constructor(public props) {
    super(props);

    this.state = {
      ...this.defaultState
    };
  }

  public componentWillReceiveProps(nextProps) {
    if (nextProps.isOpen !== this.state.isOpen) {
      if (nextProps.isOpen) {
        this.fetchExistingPayments();
      }

      this.setState({
        isOpen: nextProps.isOpen,
        step: nextProps.step ? nextProps.step : this.state.step
      });
    }

    if (nextProps.payment !== this.state.payment) {
      this.setState({payment: nextProps.payment});
    }
  }

  public clearState = () => {
    this.setState({
      ...this.defaultState
    })
  }

  public clearBackEndErrors = () => {
    this.props.dispatch({
      type: Constants.COACH_ERRORS_CLEAR
    })
  }

  public onCloseCoach = () => {
    setTimeout(() => {this.clearState()}, 100);
    this.clearBackEndErrors();

    if (this.props.onCloseCoach) {
      this.props.onCloseCoach.call(this);
    }
  }

  public closePreprocessDilaogOpen = () => {
    this.setState({
      isClosePreprocessDialogOpen: false
    });
  }

  /* Main logic for STEPPER */
  // Logic for stepper, use methods when we click button continue on step page, and we start logic.
  public handleNext = () => {
    const { activeStep } = this.state;
    const steps = this.getSteps();
    if (activeStep === steps.length - 1) { // it is last step
      this.onCloseCoach();
          
      if (typeof this.props.initializePage === "function") {
        return this.props.initializePage.call(this, this.props.charge?.id)
      }
    } else {
      switch (activeStep) {
        case 0:
          return this.startStepFirst();
        case 1:
          return this.plusOneStep();
      }
    }
  };

  public plusOneStep = () => {
    const { activeStep } = this.state;
    this.setState({
      activeStep: activeStep + 1,
    });
  }

  // Here we save all steps name and get count of steps for showing user steps name.
  public getSteps = () => {
    return [this.trans("launch-panel-settle-payment"), this.trans("coach/newtenant-step/second-title")];
  }

  //All components with content for steps we have here
  public getStepContent = (step) => {
    switch (step) {
      case 0:
        return this.stepContent(step);
      case 1:
        return this.stepContent(step);
      default:
        return this.trans("unknown-step");
    }
  }

  // Content details for diffenrent steps.
  public stepContent = (step) => {
    return (
      <div>
        {step === 0 && this.firstStepDetails()}
        {step === 1 && this.secondStepDetails()}
      </div>
    )
  }

  // Steppers components content

  public firstStepDetails = () => {
    return (
      <div>
        <div className="charges-section-wrapper">
        <Payments2List
          {...this.props}
          hideNoPaymentOption={true}
          paymentChoice={this.state.paymentChoice}
          amountForPayment={this.state.amountForPayment}
          currencyIdForPayment={this.state.currencyIdForPayment}
          dateForPayment={this.state.dateForPayment}
          paymentFirstDate={this.state.paymentFirstDate}
          typeIdForPayment={this.state.typeIdForPayment}
          agencyBankAccountIdForPayment={this.state.agencyBankAccountIdForPayment}
          counterpartyIbanForPayment={this.state.counterpartyIbanForPayment}
          originalCounterpartyIban={this.state.originalCounterpartyIban}
          paymentClassId={this.state.paymentClassId}
          payerChoice={this.state.payerChoice}
          showPayerChoice={true}
          selectedPersonForPayment={this.state.selectedPersonForPayment}
          selectedCompanyForPayment={this.state.selectedCompanyForPayment}
          descriptionForPayment={this.state.descriptionForPayment}
          descriptionForPaymentIsManuallyChanged={this.state.descriptionForPaymentIsManuallyChanged}
          filteredPayments={this.state.filteredPayments}
          selectedFilteredPaymentsRows={this.state.selectedFilteredPaymentsRows}
          scrollToEndOfPage={true}
          getPayments={this.getPayments}
          onDirectIndirectPaymentRowSelection={this.onDirectIndirectPaymentRowSelection}
          onPayerPaymentRowSelection={this.onPayerPaymentRowSelection}
          saveDetailsBeforeRedirect={this.state.payerChoice === "person" ?
            this.saveDetailsBeforeRedirect.bind(this, ["paymentSettle", "personCreate"])
            :
            this.saveDetailsBeforeRedirect.bind(this, ["paymentSettle", "companyCreate"])
          }
          autoFocusAmount={true}
          directIndirectPayments={this.state.directIndirectPayments}
          selectedDirectIndirectPaymentsRows={this.state.selectedDirectIndirectPaymentsRows}
          payerPayments={this.state.payerPayments}
          selectedPayerPaymentsRows={this.state.selectedPayerPaymentsRows}
          paymentSearchInProgress={this.state.paymentSearchInProgress}
          updatePaymentSearchString={this.updatePaymentSearchString}
          hideTotalAmount={true}
          modalDescription={this.trans("coach/settlepayment-step/first-info")}
        />
        </div>
      </div>   
    );         
  }

  public secondStepDetails = () => {
    return (
      <div>
        <div className="info-text">
          {this.trans("coach/settlepayment-step/second-info")}
        </div> 
      </div>
    );
  }

  //Funcionality for steps
  public startStepFirst = () => {
    return this.coachStartStepFirst();
  }

  public startStepSecond = () => {
    return this.coachStartStepSecond();
  }

  //Methods for step logic
  public coachStartStepFirst = () => {
    if (this.state.paymentIds?.length === 0) {
      this.onCloseCoach();
    } else {
      this.settleWithPayment(this.state.selectedPayment);
    }
  }

  public coachStartStepSecond = () => {
    this.plusOneStep();
  }

  public onPayerPaymentRowSelection = (_event, rows: number[]): void => {
    let payments: PaymentInterface[];
    let paymentsIds: number [];
    let payment = null;

    payments = rows.map(row => {
      return this.state.payerPayments[row];
    });

    paymentsIds = rows.map(row => {
      return this.state.payerPayments[row].id;
    });

    if (!!payments && payments.length > 0) {
      payment = payments[0];
    }

    // if there are payments selected in the other list first we should clear them
    if (this.state.selectedDirectIndirectPaymentsRows.length > 0) {
      this.setState({
        selectedDirectIndirectPaymentsRows: [],
        paymentIds: []
      }, () => {
        // if user click on selected payment
        // if selectRows === rows in our state, we clear this field(unselect), otherwise we set selected row.
        if(this.state.selectedPayerPaymentsRows[0] === rows[0]) {
          this.setState({
            selectedPayerPaymentsRows: [],
            paymentIds: [],
            selectedPayment: null
          });
        } else {
          this.setState({
            selectedPayerPaymentsRows: rows,
            paymentIds: paymentsIds,
            selectedPayment: payment
          });
        }
      });
    } else {
      if(this.state.selectedPayerPaymentsRows[0] === rows[0]) {
        this.setState({
          selectedPayerPaymentsRows: [],
          chargeIds: [],
          selectedCharge: null
        });
      } else {
        this.setState({
          selectedPayerPaymentsRows: rows,
          paymentIds: paymentsIds,
          selectedPayment: payment
        });
      }
    }
  }

  //Methods
  public settleWithPayment = (selectedPayment: PaymentInterface) => {
    this.setState({
      isSaving: true
    }, () => {
      this.props.dispatch({
        type: Constants.GLOBAL_PAYMENT_SETTLE_START,
        payload: {
          id: this.state.payment?.id,
          paymentId: selectedPayment.id
        },
        onSuccess: () => {
          this.setState({
            activeStep: 1,
            isSaving: false
          });
        },
        onError: () => {
          this.setState({
            isSaving: false
          });
        }
      });
    });
  }

  public onDirectIndirectPaymentRowSelection = (_event, rows: number[]): void => {
    let payments: PaymentInterface[];
    let paymentsIds: number [];
    let payment = null;

    payments = rows.map(row => {
      return this.state.directIndirectPayments[row];
    });

    paymentsIds = rows.map(row => {
      return this.state.directIndirectPayments[row].id;
    });

    if (!!payments && payments.length > 0) {
      payment = payments[0];
    }

    // if there are payments selected in the other list first we should clear them
    if (this.state.selectedPayerPaymentsRows.length > 0) {
      this.setState({
        selectedPayerPaymentsRows: [],
        paymentIds: []
      }, () => {
        // if user click on selected payment
        // if selectRows === rows in our state, we clear this field(unselect), otherwise we set selected row.
        if(this.state.selectedDirectIndirectPaymentsRows[0] === rows[0]) {
          this.setState({
            selectedDirectIndirectPaymentsRows: [],
            paymentIds: [],
            selectedPayment: null
          });
        } else {
          this.setState({
            selectedDirectIndirectPaymentsRows: rows,
            paymentIds: paymentsIds,
            selectedPayment: payment
          });
        }
      });
    } else {
      if(this.state.selectedDirectIndirectPaymentsRows[0] === rows[0]) {
        this.setState({
          selectedDirectIndirectPaymentsRows: [],
          paymentIds: [],
          selectedPayment: null
        });
      } else {
        this.setState({
          selectedDirectIndirectPaymentsRows: rows,
          paymentIds: paymentsIds,
          selectedPayment: payment
        });
      }
    }
  }

  public getPayments = (payments: PaymentInterface[], selectedPaymentsRows: number[], callback: any): any => {
    return payments
      .filter(payment => !!payment)
      .map((payment: any, index: number) => { // PaymentInterface
        let color = "#43A047";

        if (payment.amountUsed < payment.amount) {
          if (payment.amountUsed === 0) {
            color = "#F44336";
          } else {
            color = "#F5A623";
          }
        }

        if (!payment) {
          return;
        }
        const isItemSelected = selectedPaymentsRows.includes(index);
        const labelId = `enhanced-table-checkbox-${index}`;

        return (
          <TableRow
            hover
            key={`payment-${payment.id}`}
            role="checkbox"
            aria-checked={isItemSelected}
            selected={isItemSelected}
          >
            <TableCell
              padding="checkbox"
              onClick={event => {event.preventDefault(); event.stopPropagation(); callback(event, [index])}}
            >
              <Checkbox
                checked={isItemSelected}
                inputProps={{ 'aria-labelledby': labelId }}
                color="primary"
              />
            </TableCell>
            <TableCell style={{width: "24px", paddingLeft: "10px", paddingRight: "5px"}}>
              <div style={{display: "flex", alignItems: "center", justifyContent: "center", paddingTop: "4px"}}>
                <div className="icon icon-ic-payment" style={{color: color}}></div>
              </div>
            </TableCell>
            <TableCell style={{width: "20%"}}>{this.formatter.formatDate(payment.dateOfThePayment)}</TableCell>
            <TableCell style={{width: "40%"}}>
              <PaymentCounterpartyDescriptionInfoForList payment={payment} /> 
            </TableCell>
            <TableCell>
              {payment.creationTypeDisplayName && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                >
                  <div className="list-label creation-type-label">
                    {payment.creationTypeDisplayName}
                  </div>
                </div>
              )}
            </TableCell>
            <TableCell style={{ textAlign: "right", width: "40%" }}>
              <div style={{display: "inline-flex", flexDirection: "column"}}>
                <span>{payment.paymentClass.id == PaymentClassContainer.pickIdFromLabel("Payable")  && <span className="minus-style">{'-'}</span>}{this.formatter.formatNumber(payment.amount, payment.currency)}</span>
                {this.renderPaymentAmountHint(payment)}
              </div>
            </TableCell>
          </TableRow>
        );
      });
  }

  public renderPaymentAmountHint = (payment: PaymentInterface) => {
    return (
      <span
        style={{
          fontSize: "11px",
          color: "#80808091"
        }}
      >
        {payment?.getPaymentAmountHint()}
      </span>
    );
  }

  public fetchExistingPayments = (firstAutoCall?: boolean): void => {
    const paymentClassId = this.state.payment?.isPaid ?
                            PaymentClassContainer.pickIdFromLabel("Receivable") :
                            PaymentClassContainer.pickIdFromLabel("Payable");
    
    const mainPayload: any = {
      paymentClassId: paymentClassId,
      isFullyUsed: 0, // unused payments
      removed: 0,
      isAfterStartDate: 1, // do not fetch charges before start date
    };

    // manually search payments for settling
    if (!!this.state.paymentSearchString) {
      this.setState({
        paymentSearchInProgress: true
      }, () => {
        const payload = {
          ...mainPayload,
          filterValue: this.state.paymentSearchString
        };
  
        this.props.dispatch({
          type: Constants.GLOBAL_PAYMENTS_NOT_SAVE_LIST,
          payload: {...payload},
          onSuccess: (data) => {
            this.setState({
              payerPayments: data.payments,
              paymentSearchInProgress: false
            });
          }
        });
      });
    } else {
      this.setState({
        payerPayments: [],
        paymentSearchInProgress: false
      });
    }

    // should find payment for settle with the same counterparty
    if (!!this.state.selectedCounterpartyForNewPayment) {
      const payload = {
        ...mainPayload
      };

      if (this.state.selectedCounterpartyForNewPayment instanceof Person) {
        payload.contactId = this.state.selectedCounterpartyForNewPayment?.id;
      }
  
      if (this.state.selectedCounterpartyForNewPayment instanceof Company) {
        payload.companyId = this.state.selectedCounterpartyForNewPayment?.id;
      }

      return this.props.dispatch({
        type: Constants.GLOBAL_PAYMENTS_NOT_SAVE_LIST,
        payload: {...payload},
        onSuccess: (data) => {
          this.setState({
            directIndirectPayments: data.payments
          }, () => {
            if (firstAutoCall && this.state.directIndirectPayments.length) {
              this.setState({
                paymentChoice: "existing"
              });
            }
          })
        }
      })
    }
  }

  public updatePaymentSearchString = (paymentSearchString: string) => {
    this.setState({
      paymentSearchString: paymentSearchString
    }, this.fetchExistingPayments);
  }

  public renderContent = () => {
    const steps = this.getSteps();
    const { activeStep } = this.state;

    return (
      <div className="stepper-wrapper">
        <div className="stepper-container">
        { activeStep !== steps.length &&
          <Stepper activeStep={activeStep}>
            {steps.map((label) => {
              const props = {};
              const labelProps = {};
              return (
                <Step key={label} {...props}>
                  <StepLabel {...labelProps}>{label}</StepLabel>
                </Step>
              );
            })}
          </Stepper>
        }
        <div>
          <div className="step-content-wrapper step-scrollable-content first-invoice-coach">
            {this.getStepContent(activeStep)}
          </div>
        </div>
      </div>
      { activeStep !== steps.length &&
        <div className={`step-content-button-wrapper button-container ${activeStep === steps.length - 1 ? "without-cancel" : ""}`}>
          {
            activeStep !== steps.length - 1 &&
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                this.setState({
                  isClosePreprocessDialogOpen: true
                })
              }}
              className="cancel-button"
            >
              {this.trans("dialog-button/close")}
            </Button>
          }

          <div>
            {
              <Button
                variant="contained"
                color="primary"
                onClick={this.handleNext}
                disabled={activeStep === 0 && this.state.paymentIds?.length === 0}
              >
              {activeStep === steps.length - 1 ? this.trans("button-close") : this.trans("button-settle")}
            </Button>
            }
          </div>
        </div>
      }
    </div>
    )
  }

  public render() {
    return (
      <div>
        <Dialog
          className={`dialog dialog-window dialog-assistant coach-dialog coach-settle-charge has-button-padding ${this.props.innerDialogClasses}`}
          open={this.state.isOpen}
          onClose={this.onCloseCoach}
          disableBackdropClick={true}
        >
          <DialogContent>
            {this.renderContent()}
          </DialogContent>
        </Dialog>

        <PromptDialog
          {...this.props}
          title={this.trans("title-attention")}
          content={
            <div style={{width: "calc(100% - 65px)"}}>
            {this.trans("are-you-sure")
            }
            </div>
          }
          openLeavePrompt={this.state.isClosePreprocessDialogOpen}
          onClose={this.closePreprocessDilaogOpen}
          onlyPositiveButton={true}
          prioritizeClosing={true}
          withoutDefaultDilaogButtons={false}
          hideCross={true}
          actions={
            [(
              <Button
              key="modal-cancel-btn"
              color="primary"
              onClick={this.closePreprocessDilaogOpen}
              style={{height: "34px", width: "auto" }}
              >
                {this.trans("label-no")}
              </Button>
            ),
            (
              <Button
              key="modal-add-btn"
              variant="contained"
              color="primary"
              onClick={this.onCloseCoach}
              style={{height: "34px", width: "auto" }}
              >
                {this.trans("label-yes")}
              </Button>
            )]
          }
        />

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}